/* eslint-disable */
import moment from 'moment'

const isSecondNonWeekendDayFromToday = (day) => {
  const weekdayOfToday = moment().weekday()
  let dayDiff = 0
  switch (weekdayOfToday) {
    case 5:
      dayDiff = 3
      break
    default:
      dayDiff = 2
  }
  return moment(day).isSame(
    moment()
      .add(dayDiff, `days`)
      .startOf(`day`),
    `day`,
  )
}

export default isSecondNonWeekendDayFromToday
